import React from 'react';
import moment from 'moment';
import ReactiveTable from '../../Organisms/ReactiveTable/ReactiveTable';

const BuildingElements = () => {
  const columns = [
    {
      name: 'Code',
      selector: row => row.code,
      sortable: true,
    },
    {
      name: 'Element',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Created',
      selector: row => moment(row.created_at).fromNow(),
      sortable: true,
    },
    {
      name: 'Updated',
      selector: row => moment(row.updated_at).fromNow(),
      sortable: true,
    },
  ];
  return (
    <>
      <div className="col-md-12 header-container">
        <h2>Building Elements</h2>
      </div>
      <div className="col-md-12 content-container">
        <ReactiveTable
          columns={columns}
          endpoint="types/building-elements"
          exportableKeys={['name', 'code']}
          modalTitle="Building Element"
          fields={['name', 'code']}
        />
      </div>
    </>
  );
};

export default BuildingElements;
